<template>
  <div :style="style" class="loading">
    <HollowDotsSpinner
      :animation-duration="1000"
      :dot-size="12"
      :dots-num="3"
      :color="'#95a5a6'"
    />
  </div>
</template>

<script>
import HollowDotsSpinner from './HollowDotsSpinner';
export default {
  name: 'Loading',
  components: {
    HollowDotsSpinner,
  },
  props: {
    height: {
      type: String,
      default: '100px',
    },
  },
  computed: {
    style() {
      return {
        height: this.height,
      };
    },
  },
};
</script>

<style lang="scss">
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
